<template>
	<div style="width:90%"> 
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名称"></el-input>
					</el-form-item>
					<el-form-item label="店铺名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称"></el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="停用" :value="0"></el-option>
							<el-option key="1" label="正常" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="选品总数">
							<span>{{ props.row.shopNumber }}款(在售：{{props.row.goodsUpStatus}}款，下架：{{props.row.goodsDownStatus}}款)</span>
						</el-form-item>
						<el-form-item label="浏览量">
							<span>{{ props.row.pv }} </span>
						</el-form-item>
						<el-form-item label="访客量">
							<span>{{ props.row.uv }} </span>
						</el-form-item>
						<el-form-item label="入驻费用">
							<span>{{ props.row.appyPayIntegralNum }} {{props.row.name}}</span>
						</el-form-item>
						<el-form-item label="联系人">
							<span>{{props.row.linkUser?props.row.linkUser:'无'}}</span>
						</el-form-item>
						<el-form-item label="入驻支付状态">
							<span>{{props.row.paymentStatus?'已支付':'未支付'}}</span>
						</el-form-item>
						<el-form-item label="保证金支付状态" label-width="200px">
							<span>{{props.row.payStatus?'已支付':'未支付'}}</span>
						</el-form-item>
						<el-form-item label="简介">
							<span>{{props.row.storeIntro?props.row.storeIntro:'无'}}</span>
						</el-form-item>
						<el-form-item v-if="props.row.checkState==2" label="驳回原因">
							<span>{{ props.row.refuseReason }}</span>
						</el-form-item>
						<el-form-item v-if="props.row.status==0" label="禁用说明">
							<span>{{ props.row.refuseReason }}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>

			<el-table-column prop="username" label="用户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="shopNumber" label="选品总数" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="pv" label="pv" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="uv" label="uv" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="payStatus" label="保证金支付状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.payStatus == 1">已支付</p>
					<p v-if="scope.row.payStatus == 0">未支付</p>
				</template>
			</el-table-column>
			<el-table-column prop="paymentStatus" label="入驻支付状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.paymentStatus == 1">已支付</p>
					<p v-if="scope.row.paymentStatus == 0">未支付</p>
				</template>
			</el-table-column> -->
		
			

			

			<el-table-column prop="status" label="店铺状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">停用</p>
					<p v-if="scope.row.status==1">正常</p>
				</template>
			</el-table-column>
			<el-table-column prop="directPush" label="直推" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.directPush">{{scope.row.directPush}}</p>
					<p v-else>未开启</p>
				</template>
			</el-table-column>
			<el-table-column prop="indirectRecommendation" label="间推" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.indirectRecommendation">{{scope.row.indirectRecommendation}}</p>
					<p v-else>未开启</p>
				</template>
			</el-table-column>
			
			<el-table-column prop="saleNum" label="销量" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="注册时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column    label="操作"  fixed="right" align="center" width="200px">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="writeOffProductsChick(scope.row)">查看选品</el-button>　
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id);title='编辑'">编辑</el-button>　　
					<el-button size="small" type="text"  @click="editStatusShow(scope.row)">
						{{scope.row.status ? '禁用':'启用'}}</el-button>
		
				</template>
				　　</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 店铺审核 -->
		<el-dialog style="float:rigin" title="审核" :visible.sync="editDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div style="padding:0 50px">
				<el-form :model="auditInfo" label-width="80px">
					<el-form-item label="用户名">{{ auditInfo.username}}</el-form-item>
					<el-form-item label="店铺名称">{{ auditInfo.storeName}}</el-form-item>
					<el-form-item label="店铺属性">
						<span v-if="auditInfo.storeType == 0">线上店铺</span>
						<span v-if="auditInfo.storeType == 1">线下店铺</span>
					</el-form-item>
					<el-form-item label="经营类别">{{ auditInfo.className}}</el-form-item>
					<el-form-item label="联系人">
						{{ auditInfo.linkUser}}
					</el-form-item>
					<el-form-item label="手机号">
						{{ auditInfo.phone}}
					</el-form-item>
					<el-form-item label="地址">
						{{ auditInfo.province }}-{{auditInfo.city}}-{{auditInfo.area}}-{{ auditInfo.address }}
					</el-form-item>
					<el-form-item label="是否推存">
						<span v-if="auditInfo.isHot == false">不推荐</span>
						<span v-if="auditInfo.isHot == true">推荐</span>
					</el-form-item>
					<el-form-item label="店铺Logo" >
						<img :src="auditInfo.storeLogo" style="width: 100px;height: 100px;" 
						@click="clickImg(auditInfo.storeLogo)">
					</el-form-item>
					<el-form-item label="营业执照" >
						<img :src="auditInfo.licensePhoto" style="width: 100px;height: 100px;" 
						@click="clickImg(auditInfo.licensePhoto)">
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="证件照片" >
							<img v-for="(it,index) in auditInfo.bankLicenceImage" :src="it" 
							:key="index" style="width: 100px;height: 100px;" @click="clickImg(it)">
						</el-form-item>
					</div>
					<div v-if="auditInfo.storeType == 1">
						<el-form-item label="经营时间">
							<span>{{ auditInfo.businessHours}}</span>
						</el-form-item>
						<el-form-item label="配送方式">
							<span v-if="auditInfo.deliveryMethod == 1">自提/到店</span>
							<span v-if="auditInfo.deliveryMethod == 2">快递/物流</span>
							<span v-if="auditInfo.deliveryMethod == 3">不配送</span>
						</el-form-item>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="店铺照片">
								<img v-for="(item,index) in auditInfo.storeImages" :src="item" 
								:key="index" style="width: 100px;height: 100px;">
							</el-form-item>
						</div>
					</div>
					<el-form-item label="店铺简介">
						{{ auditInfo.storeIntro }}
					</el-form-item>
				</el-form>
			</div>
			<div class="app-container" v-if="auditType==2">
				<el-form ref="form" :model="form" :rules="mainFormRules" size="medium" >
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form.refuseReason" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button :loading="loading" type="primary" v-if="auditType==2"
					@click="editStoreInfoCheck(storeId,2)">驳回</el-button>
				<el-button :loading="loading" type="primary" v-if="auditType==1"
				@click="editStoreInfoCheck(storeId,1)">通过</el-button>
				
				<el-button @click="cannelPass">取 消</el-button>
			</div>
		</el-dialog>
		
		<!-- 禁用 或 启用 -->
		<el-dialog style="float:rigin" :title="formStatus.status ? '禁 用':'启 用'" :visible.sync="editStatusDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div class="app-container">
				<el-form ref="form" :model="formStatus" :rules="mainFormRules" size="medium">
					<el-form-item label="禁用说明:" v-show="formStatus.status">
						<el-col :span="18">
							<el-input v-model="formStatus.refuseReason" placeholder="请输入禁用说明" />
						</el-col>
					</el-form-item>
					
					<div style="text-align: center;">
						<el-button :loading="toStatusLoading" type="primary" @click="toStatus()">{{formStatus.status ? '禁 用':'启 用'}}
						</el-button>
						<el-button @click="editStatusDialogVisible = false">取 消</el-button>
					</div>
				</el-form>
			</div>
		</el-dialog>


		<!-- 编辑商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" :title="title" :visible.sync="dialogVisible" width="50%" >
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium" label-width="120px">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="店铺名称" >
							<el-input type="text"  v-model="storeInfo.storeName" placeholder="请输入店铺名称" />
						</el-form-item>
						<el-form-item  label="上架数量" >
							<el-input type="text" disabled v-model="storeInfo.shopNumber" placeholder="请输入店铺名称" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item  label="浏览数" >
							<el-input type="text" disabled v-model="storeInfo.pv" placeholder="请输入浏览数" />
						</el-form-item>
						<el-form-item  label="访客数" >
							<el-input type="text" disabled v-model="storeInfo.uv" placeholder="请输入访客数" />
						</el-form-item>
					</div>

					<div>
						<el-form-item label="入驻支付金额" style="width:800px;">
							{{storeInfo.appyPayIntegralNum + storeInfo.name}}
						</el-form-item>
						<el-form-item label="入驻支付状态" style="width:800px;">
							{{storeInfo.paymentStatus?'已支付':'未支付'}}
						</el-form-item>
						<el-form-item label="保证金支付状态" style="width:800px;">
							{{storeInfo.payStatus?'已支付':'未支付'}}
						</el-form-item>
					</div>

					
					
					<div style="display: flex;align-items: center;justify-content: space-between;"
					v-if="storeInfo.storeType == 1">
					<!-- store_images -->
						<el-form-item label="店铺照片">
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove1Two" :file-list="fileListTwo" :show-file-list="true" :limit="5"
								:on-success="onSuccess1Two">
								<i class="el-icon-plus"></i>
							</el-upload>

						</el-form-item>
					</div>

					<div>
						<el-form-item label="店铺简介" style="width:800px;">
							<el-input :rows="5" type="textarea" maxlength="50" show-word-limit v-model="storeInfo.storeIntro"
								placeholder="请输入店铺简介" />
						</el-form-item>
						<!-- <div style="text-align: start;margin: 10px;">店铺简介</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="storeInfo.storeIntro" ref="myQuillEditor" class="editer" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item> -->
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-show="title=='新增'" type="primary" @click="sure">添 加</el-button>
				<el-button v-show="title=='编辑'" type="primary" @click="edit" :loading="editLoading">修 改</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>


		<!-- 查看店铺各种照片 -->
		<el-dialog title="照片" :visible.sync="showContentDialog" width="50%" :closeOnClickModal="false">
			<div>
				<div>
					<img style="width: 100%;" :src="storeInfo.storeLogo" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdFace" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdBack" />
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogImg" :closeOnClickModal="false" width="700px">
			<div style="text-align: center;">
				<img width="600px" style="width:600px;height:auto" :src="popupImageUrl">
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogImg = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 查看选品 -->
		<el-dialog  title="查看选品" :visible.sync="inviteDialogVisible" width="1200px" :close-on-click-modal="false">
			<el-table :data="writeOffProducts" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="writeOffProductsLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" >
				<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="price" label="零售价格" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
					<template slot-scope="scope">
						<span>￥{{ scope.row.price | intToFourFloat}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="agreementPrice" label="分销价格" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
					<template slot-scope="scope">
						<span>￥{{ scope.row.agreementPrice | intToFourFloat}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="" label="赚" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
					<template slot-scope="scope">
						<span style="color:red;">￥{{(scope.row.price - scope.row.agreementPrice )| intToFourFloat}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="salesSum" label="总销量" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="distributionStock" label="店销量" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="distributionStatus" label="状态" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span v-if="scope.row.distributionStatus">上架</span>
						<span v-else>下架</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="saleNum" label="核销数量" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column> -->
				<el-table-column prop="createTime" label="选品时间" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
			</el-table>
			<!-- <el-pagination style="margin: 20px;" background :current-page="writeOffProducts.pageNum"
				@current-change="pageInviteChange" :page-sizes="[10, 20, 50, 100, 150, 200]" layout="total, sizes, prev, pager,next"
				:total="writeOffProducts.total" @size-change="handleInviteSizeChange">
			</el-pagination> -->
			<div style="text-align: center;">
				<el-button @click="inviteDialogVisible = false">返回</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('fx');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		filters: {
			intToFourFloat(val) {
				return (Math.floor(Number(val) * 1000) / 1000).toFixed(2)
			},
		},
		data() {
			return {
				title: '',
				httpUrl: urls,
				loading: false,
				storeList: [{}], //列表
				dialogVisible: false, // 审核
				editDialogVisible: false, // 编辑
				showContentDialog: false, //查看证件照片
				editStatusDialogVisible: false,//禁用或启用
				formStatus:{},
				accountList: [],
				username: '',
				regionId:'',
				storeInfo: {
					userId: "",
					isHot: "",
					storeLogo: "",
					storeName: "",
					storeIntro: "",
					type: "",
					linkUser: "",
					phone: "",
					legalIdNumber: "",
					legalIdFace: "",
					legalIdBack: "",
					provinceId: "",
					cityId: "",
					regionId: "",
					province: "",
					city: "",
					area: "",
					address: "",
					storeType:'', 
				},
				store_logo: [], //店铺logo
				provinceList: {},
				cityList: {},
				districtList: {},
				storeId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					status: ''
				},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				dialogVisibleDetails:false, //logo查看弹窗
				storeLoading: false,
				auditInfo: {}, //店铺审核信息
				auditType: '', //店铺审核类型

				licensePhoto:[], //店铺营业执照
				fileList: [], //证件照片
				fileListTwo: [], //店铺照片

				dialogImg:false,
				popupImageUrl:'',

				BusinessCategory:[], //经营类别

				storeIdID: '',
				writeOffProducts: [],
				inviteDialogVisible: false,
				writeOffProductsLoading: false,

				toStatusLoading: false, //禁用或启用
				editLoading: false, //编辑
			};
		},

		methods: {
			writeOffProductsChick(row){
				console.log('234--', row)
				this.storeIdID = row.id;
				// this.chainID = row.chainId;
				this.writeOffProducts=[];
				this.showWriteOff();
				this.inviteDialogVisible = true;
			},
			showWriteOff() { //查看选品
				this.writeOffProductsLoading = true;
				let data = {
					storeId: this.storeIdID, //this.chainID
					// pageNum: this.page.invitePageNum,
					// pageSize: this.page.invitePageSize,
				}
				this.$api.findstoreDistributionGoods(data).then((res) => { 
					// console.log('查看选品---', res)
					if (res.state == 'success') {
						// console.log('查看选品---', res.data.list[0])
						this.writeOffProducts = res.data.list
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
					this.writeOffProductsLoading = false
				})
			},
			getBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					isShow: true
				}
				this.$api.BusinessCategoryList(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.BusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			clickImg(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
			//上传店铺logo
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.store_logo.push({
					url: response.message
				})
			},
			handleRemove(file, fileList) {
				this.store_logo = [];
			},

			onSuccess1(response, file) {
				// console.log(response)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList.remove(file.url);
			},
			onSuccess1Two(response, file) {
				// console.log(response)
				this.fileListTwo.push({
					"url": response.message
				})
			},
			handleRemove1Two(file, fileList) {
				if (file.response) {
					this.fileListTwo.remove(file.response.message);
				}
				this.fileListTwo.remove(file.url);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handleRemoveTwo(file, fileList) {
				this.licensePhoto = [];
			},
			handlePictureCardPreview(file) {
				// this.dialogImageUrl = file.url;
				// this.dialogVisibleImg = true;

				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			

			findDetail(string) { //查看店铺描述和logo
				this.dialogVisibleDetails = true;
				this.images = string
				// this.detailType = type;
				// if (type == 1) {
				// 	this.detail = string;

				// }
				// if (type == 2) {
				// 	this.images = string.split(",");
				// }
			},
			toExamine(id,num){ // 查询店铺详细信息
				//审核驳回弹窗打开
				this.form.refuseReason = ""; //驳回原因
					
				this.auditType = num; //审核类型
				this.auditInfo = {}; //审核数据信息

				this.storeId = id
				this.$api.getStoreId(this.storeId).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.auditInfo = res.data;
						// console.log('审核信息1---',this.auditInfo )
						// this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						// this.auditInfo.storeImages = res.data.storeImages.split(',')
						if(res.data.bankLicenceImage){ //证件照片
							this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						}
						if(res.data.storeImages){  //店铺照片
							this.auditInfo.storeImages = res.data.storeImages.split(',')
						}
						// console.log('审核信息2---',this.auditInfo )
						this.editDialogVisible = true;
					}
				})
			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						username: e
					}
					this.$api.getUserNameList(data).then((res) => {
						if (res.state == 'success') {
							if (res.data && res.data.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data
							} else {
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}

				
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreList()
			},
			showFile(info) {
				this.showContentDialog = true
				this.storeInfo.storeLogo = info.storeLogo
				this.storeInfo.legalIdFace = info.legalIdFace
				this.storeInfo.legalIdBack = info.legalIdBack
			},
			//店铺提交审核
			editStoreInfoCheck(id, checkState) {
				if (checkState == 2) {
					//通过驳回
					var data = {
						id: this.storeId,
						checkState: checkState,
						refuseReason: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						checkState: checkState
					}
				}
				this.$api.editStoreInfoCheck(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreList()
					} else {
						this.$message.error(res.message);
					}
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.province = obj.name
				this.storeInfo.cityId = ""
				this.storeInfo.regionId = ""
				this.regionId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.city = obj.name
				this.storeInfo.regionId = ""
				this.regionId = ""
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				this.storeInfo.areaId = e;
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.area = obj.name
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}
				this.storeId = ""
				this.regionId = '';
				this.store_logo = [];
				this.licensePhoto = [];
				this.fileList = [];
				this.fileListTwo = [];

				if (id) {
					this.storeId = id
					this.$api.storeByIdDistribution(this.storeId).then((res) => {
						if (res.state == 'success') {
							// console.log('更具ID查询---',res.data)
							this.storeInfo = res.data;
							this.username = res.data.username;
							this.storeInfo.storeClassId = res.data.storeClassId.split(',');
							
							// this.getUserList();

							if(this.storeInfo.storeLogo){
								this.store_logo.push({
									url: this.storeInfo.storeLogo
								})
							}else{
								this.store_logo = []
							}
							if(this.storeInfo.licensePhoto){
								this.licensePhoto.push({
									url: this.storeInfo.licensePhoto
								})
							}else{
								this.licensePhoto = []
							}

							if(res.data.businessHours){
								this.storeInfo.businessHours = res.data.businessHours.split('-')
							}
							// this.fileList //证件照片
							// this.fileListTwo //店铺照片
							if(res.data.bankLicenceImage){ //证件照片
								let arr = res.data.bankLicenceImage.split(',')
								arr.map(item => { 
									this.fileList.push({
										url:item
									})
								})
							}
							if(res.data.storeImages){  //店铺照片
								let arrTwo = res.data.storeImages.split(',')
								arrTwo.map(item => { 
									this.fileListTwo.push({
										url:item
									})
								})
							}

							if (this.storeInfo.provinceId) {
								this.$api.getAreasFive(this.storeInfo.provinceId).then((res) => {
									if (res.state == 'success') {
										this.cityList = res.data
									}
								})
							}
							if (this.storeInfo.cityId) {
								this.$api.getAreasFive(this.storeInfo.cityId).then((res) => {
									if (res.state == 'success') {
										this.districtList = res.data
									}
								})
							}
							this.regionId = res.data.regionId;

							
						}
					})
				} 
				this.dialogVisible = true;
			},
			//新增店铺
			sure() {
				// this.storeInfo.storeLogo = this.logo; //店铺logo
				this.storeInfo.regionId = this.regionId;
				if(this.licensePhoto.length == 1){
					this.storeInfo.licensePhoto = this.licensePhoto[0].url; //营业执照
				}
				if(this.store_logo.length == 1){
					this.storeInfo.storeLogo = this.store_logo[0].url; //营业执照
				}
				// this.storeInfo.storeLogo = this.store_logo[0].url; //logo
				this.storeInfo.storeClassId = this.storeInfo.storeClassId.join(',');
				let arrOne = [];
				
				this.fileList.map(item => { //证件照片
					arrOne.push(item.url)

				})
				this.storeInfo.bankLicenceImage = arrOne.join(",")
				
				if(this.storeInfo.storeType == 1){
					let arrTwo = [];
					this.storeInfo.businessHours = this.storeInfo.businessHours.join("-"); //营业时间
					this.fileListTwo.map(item => { //店铺照片
						arrTwo.push(item.url)
					})
					this.storeInfo.storeImages = arrTwo.join(",")
				}

				// console.log('新增数据---',this.storeInfo)

				this.$api.addStore(this.storeInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});

						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//编辑
			edit() {				
				
				this.editLoading = true;
				// console.log('编辑数据---', data)
				this.$api.editStoreDistribution({id: this.storeId,storeName:this.storeInfo.storeName,storeIntro: this.storeInfo.storeIntro,}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.editLoading = false;
				})
			},
			editStatusShow(store){
				this.editStatusDialogVisible=true;
				this.formStatus=store;
			},
			//禁用启用
			toStatus() {
				this.toStatusLoading = true;
				let str;
				this.$api.DistributionblockUpOrStartUsing(this.formStatus).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreList();
						this.editStatusDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.toStatusLoading = false;
				})
				// if (this.formStatus == 0) {
				// 	str = "此操作将启用该店铺账号, 是否继续?"
				// } else {
				// 	str = "此操作将禁用该店铺账号, 是否继续?"
				// }
				// this.$confirm(str, '提示', {
				// 	confirmButtonText: '确定',
          		// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	console.log('点击了确定')
				// 	that.$api.editStoreBlockUpOrStartUsing(that.formStatus).then((res) => {
				// 		if (res.state == 'success') {
				// 			that.$message({
				// 				message: res.message,
				// 				type: 'success'
				// 			});
				// 			that.getStoreList();
				// 			that.editStatusDialogVisible = false;
				// 		} else {
				// 			that.$message.error(res.message);
				// 		}
				// 	})
				// }).catch(() => {
				// 	this.$message({
				// 		type: 'info',
				// 		message: '已取消'
				// 	});
				// });
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					storeName: this.searchInfo.storeName,
					type: this.searchInfo.type,
					checkState: this.searchInfo.checkState,
					orderType: this.searchInfo.orderType,
					username: this.searchInfo.username,
					isHot: this.searchInfo.isHot,
					status: this.searchInfo.status,
					storeType: this.searchInfo.storeType
				}

				this.$api.findstoreDistribution(data).then((res) => { //管理列表
					// console.log('店铺管理列表:', res.data);
					if (res.state == 'success') {
						this.storeList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},

			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.data
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.data
				})
			},

			// 上传店铺logo点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传店铺logo上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			
			// 上传营业执照点击文件触发
			handlePreviewTwo(file) {
				// console.log(file)
			},
			// 上传营业执照 上传图片前，筛选
			beforeAvatarUploadTwo(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				let imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//上传营业执照
			onSuccessTwo(response, file, fileList) {
				// console.log(response);
				this.licensePhoto.push({
					url : response.message
				});
			},

			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				console.log(editor);
			}
		},
		created() {
			this.getStoreList();
			//查询省
			this.$api.getAreasFive(0).then((res) => {
				if (res.state == 'success') {
					this.provinceList = res.data
				}
			})
			this.getBusinessCategoryList();
		}

	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>